import React from 'react'
import { WrapperLeftCol, WrapperRightCol,
    WrapperRow
} from "./bundleGroup.style";
import BundleItem from "./bundleItem";

export default function BundleGroupUI({data,styleProps}) {

    /**
     * 좌측에는 index가 짝수인 경우의 데이터를 props로 전달
     * 우측에는 index가 홀수인 경우의 데이터를 props로 전달
     */

    const leftBundle = data.bundle_list.filter((item,index) => index % 2 === 0 && item )
    const rightBundle = data.bundle_list.filter((item,index) => index % 2 !== 0 && item )


    return (
        <>
            <WrapperRow>
                <WrapperLeftCol  styleProps={styleProps}>
                    {leftBundle.map(bundleItem => (
                        <BundleItem bundleItem={bundleItem} key={bundleItem.item_id} />
                    ))}
                </WrapperLeftCol>
                <WrapperRightCol styleProps={styleProps}>
                    {rightBundle.map(bundleItem => (
                        <BundleItem bundleItem={bundleItem} key={bundleItem.item_id} />
                    ))}
                </WrapperRightCol>
            </WrapperRow>
        </>
    )
}



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/bundleGroup/bundleGroup.presenter.js